import React, { useState, useEffect } from 'react'; 
import { Link, useLocation, useNavigate } from 'react-router-dom'; 
import { Leaf } from 'lucide-react'; 
import duck from "../components/assets/duck.jpg"; 
import './Sarafrika.css';  

function Hero() {
  // Get the dark mode state from localStorage or default to true
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem('darkMode');
    return savedMode !== null ? JSON.parse(savedMode) : true;
  });
  
  const bgColor = darkMode ? 'bg-gray-900' : 'bg-white';
  const textColor = darkMode ? 'text-white' : 'text-gray-800';
  
  const location = useLocation();
  const navigate = useNavigate();
  
  // Update localStorage when darkMode changes
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
    // Dispatch an event to notify other components
    window.dispatchEvent(new CustomEvent('themeChange', { detail: { darkMode } }));
  }, [darkMode]);

  const handleNavigation = (event, targetPath, sectionId = null) => {
    event.preventDefault();
    
    if (location.pathname === targetPath) {
      if (sectionId) {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(targetPath);
      if (sectionId) {
        setTimeout(() => {
          document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  };
  
  return (
    <div className={`${bgColor} ${textColor} min-h-screen flex flex-col`}>
      <section className="ro flex-grow">
        <div className="ro-content">
          <h1 className="ro-title">
            A platform that offers structure, <br className="hide-on-mobile" />
            network, and community..
          </h1>
          
          <button className={`ro-button ${darkMode ? '' : 'light-mode'}`}>
            <a href="/shop" target="_blank" rel="noopener noreferrer">
              Explore Our Products
            </a>
          </button>
        </div>
        <div className="ro-image">
          <img src={duck} alt="Duck illustration" />
        </div>
        <div className="purple-circle circle-1"></div>
        <div className="purple-circle circle-2"></div>
        <div className="purple-circle circle-3"></div>
        <div className="purple-circle circle-4"></div>
        <div className="purple-circle circle-5"></div>
      </section>
      
    {/* Theme toggle button */}
      <button
        onClick={() => setDarkMode(!darkMode)}
        className="theme-toggle"
        aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
      >
        {darkMode ? '☀️' : '🌙'}
      </button>
    </div>
  );
}

export default Hero;